import { Phone, Clock, ShieldCheck, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/site/motion";
import LeadForm from "@/components/site/LeadForm";
import { CONTACT } from "@/data/content";

const points = [
  { icon: Clock, text: "Immediate admittance & shorter wait lists" },
  { icon: BadgeCheck, text: "Private pay & most insurance accepted — including GreenShield" },
  { icon: ShieldCheck, text: "Every conversation is 100% confidential" },
  { icon: Phone, text: "Speak with a real, caring human — 24/7" },
];

const Admissions = () => (
  <section id="admissions" className="bg-sand py-24 md:py-36 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <Reveal>
          <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Private-Pay Intake · Start Here</p>
          <h2 className="font-serif text-4xl md:text-6xl text-forest tracking-tight leading-[1.02]">
            You are not alone. <span className="italic text-terracotta">Get help today.</span>
          </h2>
          <p className="mt-6 text-ink2 text-lg leading-relaxed max-w-lg">
            Reaching out is the hardest step. Share a few details and our admissions team will call you back —
            gently, confidentially, and often within the hour. We serve private-pay clients and GreenShield members.
          </p>
        </Reveal>

        <div className="mt-10 space-y-4">
          {points.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={i} delay={i * 0.1} className="flex items-center gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-sage/20 text-forest shrink-0">
                  <Icon className="w-5 h-5" />
                </span>
                <span className="text-ink font-medium">{p.text}</span>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.3}>
          <a
            href={CONTACT.phoneHref}
            data-testid="admissions-call"
            className="mt-10 inline-flex items-center gap-3 group"
          >
            <span className="grid place-items-center w-14 h-14 rounded-full bg-forest text-sand group-hover:bg-forestdark transition-colors">
              <Phone className="w-6 h-6" />
            </span>
            <span>
              <span className="block text-xs uppercase tracking-[0.2em] text-ink2">Prefer to call?</span>
              <span className="block font-serif text-2xl text-forest">{CONTACT.phone}</span>
            </span>
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <LeadForm />
      </Reveal>
    </div>
  </section>
);

export default Admissions;
